import { types } from 'modules/expenses/services/actions';

const initialState = {};

export default function expenseDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case types.DELETE_EXPENSE_SUCCESS: {
            const { id } = action.meta;

            if (state[id]) {
                const nextState = { ...state };

                delete nextState[id];

                return nextState;
            }

            return state;
        }

        case types.UPDATE_EXPENSE_SUCCESS:
        case types.CREATE_EXPENSE_SUCCESS:
        case types.FETCH_EXPENSE_SUCCESS:
            return {
                ...state,
                [action.meta.id]: action.payload,
            };

        default:
            return state;
    }
}
